import { createFileRoute } from '@tanstack/react-router';
// applies the saved interface settings app-wide from start-up (the route tree evaluates this file eagerly)
import '@/features/settings/boot';
import { SettingsLandingPage } from '@/features/settings/SettingsLandingPage';

/** "Sozlamalar" landing (556:16443). */
export const Route = createFileRoute('/_authed/_app/settings/')({
  component: SettingsLandingPage,
});
